<ul class="toast">
    <li *ngFor="let message of messages()" style="list-style: none">
        <div [ngClass]="getMessageLevelClass(message)">
            <div class="toast-message-content">
                <ai-icon class="toast-severity-icon" [fontIcon]="getSeverityIcon(message)"></ai-icon>
                {{ message.message }}
            </div>
            <ai-button
                [transparent]="true"
                [border]="'hidden'"
                (click)="close(message)"
            >
                <ai-icon [fontIcon]="'fa-solid fa-xmark'"></ai-icon>
            </ai-button>
            <div class="toast-timer" [style.animation-duration]="(message.duration ?? timeout()) + 'ms'"></div>
        </div>
    </li>
</ul>
